<template>
  <main>
    <b-row>
      <b-col lg="6" sm="6">
        <statistic-card-horizontal @onClick="$router.push('/barang')" icon="LayersIcon" color="primary" :statistic="cardBarang" statistic-title="Barang" />
      </b-col>
      <b-col lg="6" sm="6">
        <statistic-card-horizontal @onClick="$router.push('/kendaraan')" icon="CreditCardIcon" color="success" :statistic="cardKendaraan" statistic-title="Total Kendaraan" />
      </b-col>
    </b-row>
  </main>
</template>
<script>
import { BAlert } from "bootstrap-vue";
import { BTabs, BTab, BRow, BCol, BCard } from "bootstrap-vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import AppEchartBar from "@core/components/charts/echart/AppEchartBar.vue";
import AppEchartDoughnut from "@core/components/charts/echart/AppEchartDoughnut.vue";
import AppEchartLine from "@core/components/charts/echart/AppEchartLine.vue";
export default {
  data() {
    return {
      card: {},
    };
  },
  components: {
    StatisticCardHorizontal,
    BAlert,
    BTabs,
    BTab,
    BRow,
    BCol,
    BCard,
    AppEchartBar,
    AppEchartDoughnut,
    AppEchartLine,
  },
  computed: {
    myName() {
      if (this.user) {
        return this.user.karyawan ? this.user.karyawan.nama_lengkap : this.user.email;
      }

      return null;
    },
    cardKendaraan() {
      return this.card.kendaraan ? this.card.kendaraan + " Unit" : "0 Unit";
    },

    cardBarang() {
      return this.card.barangTotal ? this.formatRupiah(this.card.barangTotal) + " Item" : "0 Item";
    },
  },
  methods: {
    postCardInfo() {
      let payload = {
        show: {
          penjualan: false,
          sales: false,
          karyawan: false,
          collection: false,
          barangTotal: true,
          kendaraan: true,
          assetTotal: false,
          assetNilai: false,
          barangMobilNilai: true,
          keuntungan: false,
        },
      };

      this.$store
        .dispatch("dashboard/cardInfo", payload)
        .then((res) => {
          this.card = res;
        })
        .catch((e) => console.error(e));
    },
  },

  created() {
    this.postCardInfo();
  },
};
</script>
